import { validationProvider } from '../infrastructure/validation/validation.provider';
export class Entity {
    constructor(id, createdAt) {
        this._id = validationProvider.validateAndTransformId(id, {
            name: 'ID',
            required: true,
        });
        this._createdAt = createdAt || undefined;
    }
    get id() {
        return this._id;
    }
    get createdAt() {
        return this._createdAt;
    }
    static buildAggregateState(events, projections, snapshot) {
        return {
            ...snapshot,
            ...events.reduce((acc, event) => {
                const eventType = event.constructor.name;
                const projection = projections[eventType];
                return {
                    ...acc,
                    ...(projection ? projection(event, acc) : {}),
                };
            }, snapshot),
        };
    }
    static restoreAggregateState(events, snapshot) {
        throw new Error('Not implemented');
    }
}
//# sourceMappingURL=entity.js.map